export const COOKIE_CONSENT_NAME = 'enno-jens-cookie-consent';
export const COOKIE_CONSENT_EVENT = 'cookie-consent-updated';

export type CookieConsent = 'accepted' | 'declined' | 'unset';

export const readCookieConsent = (): CookieConsent => {
  if (typeof document === 'undefined') return 'unset';

  const consentEntry = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${COOKIE_CONSENT_NAME}=`));

  if (!consentEntry) return 'unset';

  const value = consentEntry.split('=')[1];
  if (value === 'accepted' || value === 'declined') {
    return value;
  }

  return 'unset';
};

export const writeCookieConsent = (value: Exclude<CookieConsent, 'unset'>) => {
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);

  document.cookie = `${COOKIE_CONSENT_NAME}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  window.dispatchEvent(new Event(COOKIE_CONSENT_EVENT));
};
